import { render, staticRenderFns } from "./add-note.vue?vue&type=template&id=90c826b8&scoped=true"
import script from "./add-note.vue?vue&type=script&lang=ts"
export * from "./add-note.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c826b8",
  null
  
)

export default component.exports